export const sharePaymentLink = async (orderId, showAlert, t) => {
  try {
    const paymentLink = `${window.location.origin}/biochar-order-details/${orderId}`;
    await navigator.clipboard.writeText(paymentLink);
    showAlert("success", t("payment link copied"));

    // Create WhatsApp message with actual payment link
    // Try using i18n interpolation first, then fallback to direct message
    let whatsappMessage;
    try {
      whatsappMessage = t("payment.whatsapp.message", { paymentLink });
      // If the translation didn't work (returns the key), use fallback
      if (whatsappMessage === "payment.whatsapp.message") {
        whatsappMessage = `Hi! Please complete your biochar order payment using this link: ${paymentLink}`;
      }
    } catch {
      // Fallback message if translation fails
      whatsappMessage = `Hi! Please complete your biochar order payment using this link: ${paymentLink}`;
    }

    // Debug logging
    console.log("Payment Link:", paymentLink);
    console.log("WhatsApp Message:", whatsappMessage);

    const encodedMessage = encodeURIComponent(whatsappMessage);
    const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  } catch (error) {
    console.error("Error sharing payment link:", error);
    showAlert("error", t("payment link share failed"));
  }
};
